import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Define styles for the select FIELD itself
const selectFieldStyle = {
  backgroundColor: '#251521', // Make the select field transparent, matching other inputs
 // Default text color for readability on transparent background. Adjust if needed.
  fontSize: '1.6rem',
  // border: '1px solid violet', // Keep your consistent border
};

const AffiliateForm = () => {
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [submitStatusType, setSubmitStatusType] = useState(null);
  const [errors, setErrors] = useState({});

const boxStyle = {
        width: '100%',
        // maxWidth: '400px',
        padding: '20px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus(null);
    setSubmitStatusType(null);
    setErrors({});

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    const platforms = [];
    formData.getAll('promotion_platforms').forEach(platform => {
        platforms.push(platform);
    });
    data.promotion_platforms = platforms.join(', ');

    data.agreement = !!data.agreement;

    try {
      const response = await fetch(`${API_BASE_URL}/affiliate-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        if (result.errors) {
          setErrors(result.errors);
          setSubmitStatus('Please fix the errors below and try again.');
          setSubmitStatusType('danger');
        } else {
          setSubmitStatus(result.message || 'Submission failed.');
          setSubmitStatusType('danger');
        }
      } else {
        setSubmitStatus(result.message || 'Affiliate request submitted successfully!');
        setSubmitStatusType('success');
        setErrors({});
        e.target.reset();
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('Network or server error. Please try again.');
      setSubmitStatusType('danger');
    } finally {
      setLoading(false);
    }
  };

  const hasError = (field) => errors && errors[field] && errors[field].length > 0;

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <div className="p-4">

            <Form className="px-5" style={boxStyle} onSubmit={handleSubmit} noValidate>
              {/* Full Name */}
              <Form.Group className="mb-3" controlId="full_name">
                <Form.Label>Full Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="full_name"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('full_name')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('full_name') && errors.full_name[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Email Address */}
              <Form.Group className="mb-3" controlId="email_address">
                <Form.Label>Email Address *</Form.Label>
                <Form.Control
                  type="email"
                  name="email_address"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('email_address')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('email_address') && errors.email_address[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Phone Number */}
              <Form.Group className="mb-3" controlId="phone_number">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone_number"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('phone_number')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('phone_number') && errors.phone_number[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* WhatsApp Number */}
              <Form.Group className="mb-3" controlId="whatsapp_number">
                <Form.Label>WhatsApp Number *</Form.Label>
                <Form.Control
                  type="tel"
                  name="whatsapp_number"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('whatsapp_number')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('whatsapp_number') && errors.whatsapp_number[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Location (City & Country) */}
              <Form.Group className="mb-3" controlId="location">
                <Form.Label>Location (City & Country) *</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('location')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('location') && errors.location[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Your Website / Social Media Link */}
              <Form.Group className="mb-3" controlId="website_social_media_link">
                <Form.Label>Your Website / Social Media Link *</Form.Label>
                <Form.Control
                  type="text"
                  name="website_social_media_link"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('website_social_media_link')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('website_social_media_link') && errors.website_social_media_link[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Which audience do you primarily serve? */}
              <Form.Group className="mb-3" controlId="primary_audience">
                <Form.Label>Which audience do you primarily serve? *</Form.Label>
                <Form.Control
                  as="select"
                  name="primary_audience"
                  required
                  style={selectFieldStyle}
                  isInvalid={hasError('primary_audience')}
                  className='text-white'
                >
                  <option value="">Select an audience</option>
                  {["Business Owners", "Students", "Freelancers", "Influencers", "Coaches/Consultants", "Others (please specify)"].map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {hasError('primary_audience') && errors.primary_audience[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* How many followers/email subscribers do you have (approximate)? */}
              <Form.Group className="mb-3" controlId="followers_subscribers">
                <Form.Label>How many followers/email subscribers do you have (approximate)? *</Form.Label>
                <Form.Control
                  type="text"
                  name="followers_subscribers"
                  required
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('followers_subscribers')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('followers_subscribers') && errors.followers_subscribers[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Which platforms do you use to promote content? */}
              <Form.Group className="mb-3">
                <Form.Label>Which platforms do you use to promote content? *</Form.Label>
                {["Facebook", "Instagram", "YouTube", "LinkedIn", "WhatsApp", "Email", "Website", "Other"].map((platform, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    label={platform}
                    id={`platform-${platform}`}
                    name="promotion_platforms"
                    value={platform}
                    isInvalid={hasError('promotion_platforms')}
                  />
                ))}
                <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                  {hasError('promotion_platforms') && errors.promotion_platforms[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Why do you want to join the PWU Affiliate Program? */}
              <Form.Group className="mb-3" controlId="reason_to_join">
                <Form.Label>Why do you want to join the PWU Affiliate Program? *</Form.Label>
                <Form.Control
                  as="textarea"
                  name="reason_to_join"
                  required
                  rows={4}
                  style={{ backgroundColor: 'transparent' }}
                  isInvalid={hasError('reason_to_join')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('reason_to_join') && errors.reason_to_join[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Have you done affiliate marketing before? */}
              <Form.Group className="mb-3">
                <Form.Label>Have you done affiliate marketing before? *</Form.Label>
                <div>
                  {["Yes", "No"].map((option, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      name="done_affiliate_marketing"
                      label={option}
                      id={`affiliate-marketing-${option}`}
                      value={option}
                      required
                      isInvalid={hasError('done_affiliate_marketing')}
                    />
                  ))}
                  <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                    {hasError('done_affiliate_marketing') && errors.done_affiliate_marketing[0]}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* How did you hear about us? */}
              <Form.Group className="mb-3" controlId="how_heard_about_us">
                <Form.Label>How did you hear about us? *</Form.Label>
                <Form.Control
                  as="select"
                  name="how_heard_about_us"
                  required
                  style={selectFieldStyle}
                  isInvalid={hasError('how_heard_about_us')}
                  className='text-white'
                >
                  <option value="">Select an option</option>
                  {["PWU Website", "Social Media", "Referral", "PWU Student", "Other"].map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {hasError('how_heard_about_us') && errors.how_heard_about_us[0]}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Payment Method */}
<Form.Group className="mb-3" controlId="payment_method">
  <Form.Label>Payment Method *</Form.Label>
  <Form.Control
    as="select"
    name="payment_method"
    required
    style={selectFieldStyle}
    isInvalid={hasError('payment_method')}
    className='text-white'
  >
    <option value="">Select Payment Method</option>
    {["Bkash", "Nagad", "Bank"].map((method, index) => (
      <option key={index} value={method}>{method}</option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">
    {hasError('payment_method') && errors.payment_method[0]}
  </Form.Control.Feedback>
</Form.Group>
{/* Payment Method Details */}
<Form.Group className="mb-3" controlId="payment_method_details">
  <Form.Label>Payment Method Details *</Form.Label>
  <Form.Control
    type="text"
    name="payment_method_details"
    placeholder="Enter your account number or wallet ID"
    required
    style={{ backgroundColor: 'transparent' }}
    isInvalid={hasError('payment_method_details')}
  />
  <Form.Control.Feedback type="invalid">
    {hasError('payment_method_details') && errors.payment_method_details[0]}
  </Form.Control.Feedback>
</Form.Group>


              {/* Agreement */}
              <Form.Group className="mb-3" controlId="agreement">
                <Form.Check
                  type="checkbox"
                  name="agreement"
                  label="I agree to promote PWU ethically and follow all brand guidelines."
                  required
                  isInvalid={hasError('agreement')}
                />
                <Form.Control.Feedback type="invalid">
                  {hasError('agreement') && errors.agreement[0]}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-5 mb-5">
                <Button className="btn-default" variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{' '}
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </Button>
              </div>
            </Form>
            {submitStatus && (
              <Alert variant={submitStatusType}>
                {submitStatus}
              </Alert>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AffiliateForm;